// extracted by mini-css-extract-plugin
export var character = "g_w";
export var pic = "g_x";